import { logger } from '@rea-argonaut/observability';

export const safelyDecodeURI = (uri: string): string => {
  try {
    return decodeURI(uri);
  } catch {
    logger.log(`Error decoding URI: ${uri}`);
    return '';
  }
};

export const removeInvalidQueryStringCharacters = (input: string): string => {
  if (typeof input !== 'string') return '';
  const invalidQueryStringCharactersRegex = /(%3[ce])|<|>/gi;
  return input.replace(invalidQueryStringCharactersRegex, '');
};

export const extractQueryStringFromUrl = (url: string): string => {
  if (url.indexOf('?') === -1) return '';
  return removeInvalidQueryStringCharacters(
    safelyDecodeURI(url.substring(url.indexOf('?') + 1).trim()),
  );
};

export const extractQueryAsParamsFromUrl = (url: string): Record<string, string> =>
  Object.fromEntries(new URLSearchParams(extractQueryStringFromUrl(url)));
